// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260708.1783526467/static/js/" + chunkId + "." + {"249":"60470de8","463":"1661b4bd"}[chunkId] + ".chunk.js";
};